import React, { useState, useEffect, Component } from "react";
import Cookies from "js-cookie";
import BASE_URL from "../config";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReusableButtonComponent from "../CommonComponents/ReusableButtonComponent";

const TransactionsType = (props) => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  const [pageComponent, setPageComponent] = useState("transaction_types");
  const [data, setData] = useState(undefined);
  const [code, setCode] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [emptyCode, setEmptyCode] = useState(false);
  const [emptyDesc, setEmptyDesc] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  function setSelectedRow(rowid) {
    axios
      .get(`${BASE_URL}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data;
        setSelectRowData(selectRowData);
        setCode(
          selectRowData.transaction_type.transaction_type_code
            ? selectRowData.transaction_type.transaction_type_code
            : ""
        );
        setTransactionType(
          selectRowData.transaction_type.transaction_type
            ? selectRowData.transaction_type.transaction_type
            : ""
        );
        setBtnActive(false);
      });
  }

  const createNewRow = () => {
    setBtnActive(false);
    setSelectRowData("");
    setCode("");
    setTransactionType("");
  };

  const edditRow = (event) => {
    event.preventDefault();
    if (selectRowData !== "") {
      const inputData = { Code: code, TransactionType: transactionType };
      axios
        .post(
          `${BASE_URL}${pageComponent}/update/${selectRowData.transaction_type.id}`, inputData,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authtoken}`,
            },
          }
        )
        .then((response) => {
          toast.success("Successfully Save Data ! ", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setTimeout(window.location.reload.bind(window.location), 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      toast.error("Please Select data Row", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handleSave = async (event) => {
    if (code.length === 0) {
      toast.error("Transaction Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyCode(true);
      setEmptyInput(true);
    } else {
      setEmptyCode(false);
    }

    if (transactionType.length === 0) {
      toast.error("Transaction Class can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyDesc(false);
    }

    if (emptyInput !== true) {
      const inputData = { Code: code, TransactionType: transactionType };
      const duplicate = await data.some((el) => el.Code === code);
      if (duplicate !== true) {
        axios
          .post(`${BASE_URL}${pageComponent}/store`, inputData)
          .then((response) => {
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setTimeout(window.location.reload.bind(window.location), 2000);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("This currency code already included", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
    }
  };

  useEffect(() => {
    fetch(`${BASE_URL}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.transaction_types);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [authtoken, pageComponent]);

  const deleteRow = (event) => {
    event.preventDefault();
    axios.delete(
      `${BASE_URL}${pageComponent}/${selectRowData.transactiontypes.id}/destroy`,
      selectRowData.transactiontypes.id
    );
    toast.warning("Successfully Deleted Data Row", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setTimeout(window.location.reload.bind(window.location), 2000);
  };

  const tTitle = ["Transaction Type Code", "Transaction Type"];
  const columns = ["transaction_type_code", "transaction_type"];

  const handleButtonClickPDF = () => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(columns) || columns.length === 0) {
      // Handle the scenario where the data or selected keys are invalid or empty
      toast.error("Invalid data or selected keys for export.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const filteredRows = data.map(obj => {
      const filteredRow = {};
      columns.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          filteredRow[key] = obj[key];
        }
      });
      return filteredRow;
    });

    const doc = new jsPDF();
    const rows = filteredRows.map(obj => Object.values(obj));

    const columnStyles = {}; // Object to hold column styles

    // Set cell widths (adjust widths as needed)
    columns.forEach(key => {
      columnStyles[key] = { cellWidth: 30 }; // Change width as per your requirement
    });

    doc.autoTable({
      columns: tTitle.map(key => ({ header: key, dataKey: key })),
      body: rows,
      columnStyles,
      startY: 5, // Adjust the starting Y position for the table
      // ... other configuration options
    });

    // Save the PDF file
    const dateTime = new Date().toISOString().replace(/[-T:.Z]/g, '');
    const fileName = `Transactions_Type_PDF_Report_${dateTime}.pdf`;
    doc.save(fileName);
  };

  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="001"
                    name="code"
                    value={code}
                    readOnly={selectRowData !== "" ? true : false}
                    className={emptyCode === true ? "border-red2" : ""}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Transaction Type</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Invoice"
                    name="transactionType"
                    value={transactionType}
                    className={emptyDesc === true ? "border-red2" : ""}
                    onChange={(e) => setTransactionType(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                <ReusableButtonComponent
                  selectedAuthority={props.selectedAuthority}
                  action="save"
                  label="Save"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                />

                <ReusableButtonComponent
                  selectedAuthority={props.selectedAuthority}
                  action="new"
                  label="New"
                  onClick={createNewRow}
                />

                <ReusableButtonComponent
                  selectedAuthority={props.selectedAuthority}
                  action="edit"
                  label="Update"
                  onClick={edditRow}
                  disabled={btnActive}
                />

                <ReusableButtonComponent
                  selectedAuthority={props.selectedAuthority}
                  action="delete"
                  label="Delete"
                  onClick={deleteRow}
                  disabled={btnActive}
                />

                <ReusableButtonComponent
                  selectedAuthority={props.selectedAuthority}
                  action="print"
                  label="Print"
                  onClick={handleButtonClickPDF}
                />


                {/* <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button> */}
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default TransactionsType;
